module.exports = __webpack_public_path__ + "img/Convertible_Back_Side_Right.65d1762c.svg";